<img :src="imgSrc" :srcset="imgSrcSet">